var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_13684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2087 13.5977H3.60971C1.61717 13.5977 0 15.1903 0 17.1551V32.4459C0 34.4107 1.61717 36.0008 3.60971 36.0008H24.2087C26.2038 36.0008 27.8184 34.4082 27.8184 32.4459V17.1551C27.8184 15.1903 26.2038 13.5977 24.2087 13.5977Z",
    fill: "#0074E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8174 5.97299C27.8277 9.28232 25.1127 11.9713 21.7524 11.9814C18.3921 11.9941 15.6617 9.31777 15.6514 6.00844C15.6411 2.69911 18.3561 0.010128 21.7164 0C21.7293 0 21.7396 0 21.7524 0C25.0999 0.010128 27.8097 2.67886 27.8174 5.97299Z",
    fill: "#0074E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99304 11.9489C9.34307 11.9894 12.0915 9.34602 12.1301 6.04682C12.1712 2.74763 9.48705 0.0409166 6.13702 0.000404575C2.78698 -0.0375755 0.0411363 2.6033 0 5.9025C0 5.92529 0 5.95061 0 5.9734C0 9.24474 2.67129 11.9084 5.99304 11.9489Z",
    fill: "#0074E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4286 16.9833L30.1475 21.6397V27.9039L37.4286 32.5602C38.5495 33.2185 40.0022 32.859 40.6706 31.7525C40.8609 31.4385 40.974 31.0841 40.9997 30.7194V18.9178C40.9612 17.6315 39.871 16.6213 38.565 16.6592C38.1639 16.6719 37.7731 16.7833 37.4286 16.9833Z",
    fill: "#FF724F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_13684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.7895c982593d4e1a02af99973e6f19b3.svg";
export { ForwardRef as ReactComponent };